import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { InstallationsSearchSelectors } from './installations-search.selectors';

@Injectable({ providedIn: 'root' })
export class InstallationsSearchStore {
  state$ = this.store.select(InstallationsSearchSelectors.getState());

  searchedGateway$ = this.store.select(InstallationsSearchSelectors.filteredGateway());
  constructor(private store: Store) {}
}
